// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.comments-title {\n  font-weight: bold;\n  font-size: 1.25rem;\n  margin-bottom: 16px;\n}\n.comment {\n  margin-bottom: 20px;\n}\n.comment .comment-header {\n  font-weight: bold;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.comment .comment-header .comment-author {\n  text-align: right;\n}\n.comment .comment-content {\n  white-space: pre-wrap;\n}\n", ""]);
// Exports
module.exports = exports;
